import React, { useEffect } from "react";

import PageTitle from "components/elements/PageTitle";
import BadgesTable from "components/modules/Credits/BadgesTable";
import CreditsVoucher from "components/modules/Credits/CreditsVoucher";
import Transactions from "components/modules/Credits/Transactions";
import { useUserDataContext } from "context/UserDataContext";
import { useAPIBadges, useAPIBadgeTypes } from "hooks/useAPI";

import AffiliateBox from "./AffiliateBox";
import Buy from "./Buy";
import BuyCreditsVouchers from "./BuyCreditsVouchers";
import Overview from "./Overview";
import Recharge from "./Recharge";
import Subscription from "./Subscription";

const CreditsDashboardPage: React.FC = () => {
  const { creditsBalance, creditsUnclaimed, badgesCount, refreshData } = useUserDataContext();
  const { data: badgeTypesData } = useAPIBadgeTypes();
  const { data: badgesData } = useAPIBadges();

  useEffect(() => {
    refreshData?.();
  }, [badgesData?.badges.length, badgesCount, creditsUnclaimed, creditsBalance]);

  return (
    <>
      <PageTitle i18nKey="creditsPage.meta_title" />
      <Overview
        badges={badgesCount}
        badgesTotal={badgeTypesData?.badgeTypes.length}
        credits={creditsBalance}
        creditsUnclaimed={creditsUnclaimed}
      />
      <BadgesTable />
      <Subscription />
      <Recharge />
      <Buy />
      <BuyCreditsVouchers />
      <AffiliateBox />
      <Transactions limit={5} />
      <CreditsVoucher refreshData={refreshData} />
    </>
  );
};

export default CreditsDashboardPage;
